import { useDeepCompareEffect } from 'hooks/useDeepCompareEffect'
import usePrevious from 'hooks/usePrevious'
import { useEffect, useState } from 'react'
import request from 'services/request'
import { MessageConfigRspModel, MessageListModel, MessageModel } from 'services/types/Message'
import { useMessageInfo, useUser } from 'state/user/hooks'

export function getMessageInfo() {
  return request.get('message/v1/info')
}

export function getMessageUnreadInfo() {
  return request.get('message/v1/unread/info')
}

export function markRead(type: number | string) {
  return request.post(`message/v1/mark/${type}`)
}

export function chooseMark(id: number | string) {
  return request.post(`message/v1/choose/mark`, { id })
}

export function useUnreadList(): Array<MessageModel> {
  const [data, setData] = useState<Array<MessageModel>>([])
  const message = useMessageInfo()
  const user = useUser()
  const previous = usePrevious(data)
  useEffect(() => {
    if (!previous && user) {
      request
        .get<Array<MessageModel>>('message/v1/unread/list')
        .then(res => {
          if (res.code === 200) {
            setData(res.data)
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }, [previous, user, message.unreadNum])
  return data
}

export function useMessageList(
  params: { pageSize: number; currentPage: number; readFlag: boolean },
  type: string | number
): {
  loading: boolean
  hasNextPage: boolean
  list: Array<MessageModel>
} {
  const [list, setList] = useState<Array<MessageModel>>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [hasNextPage, setHasNextPage] = useState<boolean>(true)
  useEffect(() => {
    setList([])
  }, [type])
  useDeepCompareEffect(() => {
    if (!loading) {
      setLoading(true)
      request
        .post<MessageListModel>(`message/v1/list/${type}`, { ...params, readFlag: params.readFlag ? 0 : null })
        .then(res => {
          setHasNextPage(res.data.pages > params.currentPage)
          setLoading(false)
          if (res.code === 200) {
            if (params.currentPage === 1) {
              setList(res.data.records)
            } else if (list) {
              setList(list => [...list, ...res.data.records])
            }
          }
        })
        .catch(err => {
          setHasNextPage(false)
          setLoading(false)
          console.error(err)
        })
    }
  }, [params, type])
  return { loading, hasNextPage, list }
}

export function messageSetup(data: { [key in keyof MessageConfigRspModel]?: number }) {
  return request.post(`message/v1/setup`, data)
}
